const BARS = [
  { duration: 0.9, delay: 0 },
  { duration: 0.7, delay: 0.15 },
  { duration: 1.05, delay: 0.05 },
  { duration: 0.8, delay: 0.2 },
  { duration: 0.95, delay: 0.1 },
];

/** Decorative speech-waveform that pulses in under a nav item on hover/focus. */
export function NavWaveform() {
  return (
    <span
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-full mt-1.5 flex h-2.5 -translate-x-1/2 items-end gap-[3px] opacity-0 scale-90 origin-bottom transition-all duration-300 group-hover:opacity-100 group-hover:scale-100 group-focus-visible:opacity-100 group-focus-visible:scale-100"
    >
      {BARS.map((bar, i) => (
        <span
          key={i}
          className="nav-wave-bar w-[3px] h-full rounded-full bg-accent origin-bottom"
          style={{ animationDuration: `${bar.duration}s`, animationDelay: `${bar.delay}s` }}
        />
      ))}
    </span>
  );
}
